import React from 'react';
import { FaInbox } from 'react-icons/fa';

const EmptyState = ({ 
  icon: Icon = FaInbox, 
  title = 'No data found', 
  description = 'There is no data to display at the moment.',
  action,
  actionText
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-12 text-center">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-4">
        <Icon className="text-4xl text-gray-400" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        {title}
      </h3>
      <p className="text-gray-600 max-w-md mb-6">
        {description}
      </p>
      {action && actionText && (
        <button
          onClick={action}
          className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-200"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
